<template>
  <div>
    <v-form ref="form" autocomplete="off" @submit.prevent="noopSubmit">
        <v-row>
            <v-col cols="12" :sm="stacked ? 12 : 6">
                <v-text-field
                    prepend-icon="badge"
                    name="nombre"
                    v-model="form.nombre"
                    :label="$t('proveedor.labels.nombre')"
                    :placeholder="$t('proveedor.labels.nombre')"
                    :error="hasInputErrors('nombre')"
                    :error-messages="getInputErrors('nombre')"
                    color="secondary"
                    :rules="required"
                ></v-text-field>
            </v-col>
            <v-col cols="12" :sm="stacked ? 12 : 6">
                <v-text-field
                    prepend-icon="numbers"
                    name="cuit"
                    :value="form.cuit"
                    @input="onCuitInput"
                    :label="$t('proveedor.labels.cuit')"
                    placeholder="30-71513211-3"
                    :error="hasInputErrors('cuit')"
                    :error-messages="getInputErrors('cuit')"
                    color="secondary"
                ></v-text-field>
            </v-col>
            <v-col cols="12" :sm="stacked ? 12 : 6">
                <v-text-field
                    prepend-icon="email"
                    name="email"
                    v-model="form.email"
                    :label="$t('proveedor.labels.email')"
                    :placeholder="$t('proveedor.labels.email')"
                    :error="hasInputErrors('email')"
                    :error-messages="getInputErrors('email')"
                    color="secondary"
                ></v-text-field>
            </v-col>
            <v-col cols="12" :sm="stacked ? 12 : 6">
                <v-text-field
                    prepend-icon="phone"
                    name="telefono"
                    v-model="form.telefono"
                    :label="$t('proveedor.labels.telefono')"
                    :placeholder="$t('proveedor.labels.telefono')"
                    :error="hasInputErrors('telefono')"
                    :error-messages="getInputErrors('telefono')"
                    color="secondary"
                ></v-text-field>
            </v-col>
        </v-row>
    </v-form>

    <v-dialog v-model="ocReminderOpen" max-width="520" persistent>
      <v-card>
        <v-card-title class="text-h6">
          <v-icon left color="amber darken-2">mdi-file-document-alert-outline</v-icon>
          {{ $t('proveedor.ordenCompraReminderTitle') }}
        </v-card-title>
        <v-card-text class="pt-2">
          {{ $t('proveedor.ordenCompraReminderText') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cancelOcReminder">
            {{ $t('common.cancel') }}
          </v-btn>
          <v-btn color="primary" @click="confirmOcReminder">
            {{ $t('common.confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

    import {InputErrorsByProps, RequiredRule } from '@dracul/common-frontend'
    import { applyCuitCuilInput, formatCuitCuilDisplay } from '../../../../../utils/cuitCuilFormat'

    export default {
        name: "ProveedorForm",
        mixins: [InputErrorsByProps, RequiredRule],
        
        props:{
            value: {
                type: Object,
                required: true
            },
            /** En true, los campos se muestran en una sola columna (p. ej. en modales). */
            stacked: {
                type: Boolean,
                default: false
            },
            /** Si es false, no muestra el recordatorio antes de guardar (p. ej. usos internos). */
            confirmOrdenCompraReminder: {
                type: Boolean,
                default: true,
            },
        },
        computed: {
           form: {
                get() { return this.value },
                set(val) {this.$emit('input', val)}
            }
        },
         watch: {
            form: {
                handler(newVal) {
                    this.$emit('input', newVal)
                },
                deep: true
            }
        },
        methods: {
            noopSubmit() {},
            validate(){
              return this.$refs.form.validate()
            },
            /** Valida el formulario; si ok, muestra recordatorio de OC y luego ejecuta onProceed. */
            validateThenConfirm(onProceed) {
              if (typeof onProceed !== 'function') return
              if (!this.$refs.form.validate()) return
              if (!this.confirmOrdenCompraReminder) {
                onProceed()
                return
              }
              this.pendingSubmit = onProceed
              this.ocReminderOpen = true
            },
            cancelOcReminder() {
              this.ocReminderOpen = false
              this.pendingSubmit = null
            },
            confirmOcReminder() {
              const fn = this.pendingSubmit
              this.ocReminderOpen = false
              this.pendingSubmit = null
              if (fn) fn()
            },
            onCuitInput(val) {
                this.form.cuit = applyCuitCuilInput(val)
            },
        },
        created() {
            if (this.form.cuit) {
                this.form.cuit = formatCuitCuilDisplay(this.form.cuit)
            }
        },
        data(){
            return {
                ocReminderOpen: false,
                pendingSubmit: null,
            }
        },
    }
</script>

<style scoped>

</style>
